import { GetServerSidePropsContext, NextPageContext } from 'next';
import { AppContext } from 'next/app';

type NextPageContextApp = NextPageContext & AppContext;

interface PathMatchOptions {
    context: (GetServerSidePropsContext | NextPageContextApp) & {
        asPath?: string;
    };
    includedPaths?: RegExp[];
    excludedPaths?: RegExp[];
}

export const hasPathMatch = ({
    context,
    includedPaths = [],
    excludedPaths = []
}: PathMatchOptions): boolean => {
    const fullUrl =
        'https://zoopla.co.uk' + (context.req?.url || context.asPath);
    const parsedUrl = new URL(fullUrl);
    const pathWithParams = parsedUrl.pathname + parsedUrl.search;

    const isMatchExcluded = excludedPaths.some((regex) =>
        regex.test(pathWithParams)
    );

    if (isMatchExcluded) return false;

    return includedPaths.some((regex) => regex.test(pathWithParams));
};
